import { Box } from 'components/primitives/box';

export default (props) => {
  const { additionalClasses, children } = props;
  return (
    <Box
      background="white"
      className={` ${additionalClasses || ''} u-sm-phz1 u-phz1 u-pv1 u-bottom-0 u-left-0 u-posFixed`}
      style={{
        width: '100%',
        zIndex: 997,
        boxShadow: '0px -5px 6px -1px rgba(0,0,0,0.10)',
      }}
    >
      {children}
    </Box>
  );
};
